<template>
  <div class="alert" v-show="msg" transition="expand">{{msg}}</div>
</template>

<script>
export default {
  data: function() {
    return {
      msg: ""
    }
  },
  ready: function() {
    let self = this

    this.$events.$on('alert', function(msg) {
      self.msg = msg
      setTimeout(function() {
        self.msg = null
      }, 2000)
    });
  }
}
</script>

<style>
.alert {
  padding: 2rem;
  background: #97cd76;
  position: fixed;
  top: 0; width: 100%;
  z-index: 100;
  color: white;
}

.expand-transition {
  transition: all .3s ease;
  transform-origin: top;
  transform: scaleY(1);
}

.expand-enter, .expand-leave {
  transform: scaleY(0);
}
</style>



/** WEBPACK FOOTER **
 ** Alert.vue?dee104a6
 **/